import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ModalService } from '../modal.service';

@Component({
    selector: 'aa-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: [
        './confirm-modal.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmModalComponent implements OnInit
{
    constructor(private modalService: ModalService) { }

    ngOnInit ()
    {
    }

    public close (dialogResult: boolean)
    {
        this.modalService.destroy(dialogResult);
    }
}
